import axios from 'axios';

const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL

class AuthService {
  async login(request_data) {
      try {
        const response = await axios
          .post(API_URL + `/Auth/Login`,request_data);
        return response;
      }
      catch (error) {
        return error.response;
      }
  }

  async signup(authToken,request_data) {
    // console.log("authToken | ", authToken)
      try {
        const response = await axios
          .post(API_URL + `/Signup/SellerUser`,request_data);
        return response;
      }
      catch (error) {
        return error.response;
      }
  }

  async checkValidTokenAsync(token) {
    
      try {
        const response = await axios
          .post(API_URL + `/Signup/Seller/Verify?Token=${token}`);
        return response;
      }
      catch (error) {
        return error.response;
      }
  }

  

  async refreshToken(request_data){
    try {
      const response = await axios
        .post(API_URL + `/Auth/Refresh`,request_data);
      return response;
    }
    catch (error) {
      return error.response;
    }
  }

}

export default new AuthService();